import React from 'react';

const RightArrowIcon = (props) => {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M6 16a1 1 0 0 1 1-1h15.564l-2.125-2.27a1 1 0 0 1-.076-1.276l.084-.1.096-.097a.976.976 0 0 1 1.29-.039l.09.084 3.688 3.94c.162.173.251.39.267.611l.001.133a.997.997 0 0 1-.268.744l-3.689 3.939a.976.976 0 0 1-1.38.045l-.095-.097a1 1 0 0 1-.008-1.375L22.538 17H7a1 1 0 0 1-1-1z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  );
};

export default RightArrowIcon;
